"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromLocalStorage = void 0;
var getValueFromLocalStorage = function (key, defaultValue) {
    var value = localStorage.getItem(key);
    if (value) {
        return JSON.parse(value);
    }
    return defaultValue;
};
exports.getValueFromLocalStorage = getValueFromLocalStorage;
